const { default: preactClient } = require('app/desktop/client');

preactClient();

//Do not remove or hash on dynamic imports will not update
export default () => {};
